export const SET_DISCUSSIONS_ERROR = 'SET_DISCUSSIONS_ERROR';
export const CLEAR_DISCUSSIONS_ERROR = 'CLEAR_DISCUSSIONS_ERROR';

export const TOGGLE_DISCUSSIONS_LOADING = 'TOGGLE_DISCUSSIONS_LOADING';

export const LECTURE_DISCUSSION_REQUEST = 'LECTURE_DISCUSSION_REQUEST';
export const LECTURE_DISCUSSION_FAILURE = 'LECTURE_DISCUSSION_FAILURE';
export const LECTURE_DISCUSSION_SUCCESS = 'LECTURE_DISCUSSION_SUCCESS';

export const ADD_DISCUSSION_ENTRY_REQUEST = 'ADD_DISCUSSION_ENTRY_REQUEST';
export const ADD_DISCUSSION_ENTRY_FAILURE = 'ADD_DISCUSSION_ENTRY_FAILURE';
export const ADD_DISCUSSION_ENTRY_SUCCESS = 'ADD_DISCUSSION_ENTRY_SUCCESS';

export const GENERAL_DISCUSSION_REQUEST = 'GENERAL_DISCUSSION_REQUEST';
export const GENERAL_DISCUSSION_FAILURE = 'GENERAL_DISCUSSION_FAILURE';
export const GENERAL_DISCUSSION_SUCCESS = 'GENERAL_DISCUSSION_SUCCESS';

export const GENERAL_DISCUSSION_ENTRY_REQUEST =
  'GENERAL_DISCUSSION_ENTRY_REQUEST';
export const GENERAL_DISCUSSION_ENTRY_FAILURE =
  'GENERAL_DISCUSSION_ENTRY_FAILURE';
export const GENERAL_DISCUSSION_ENTRY_SUCCESS =
  'GENERAL_DISCUSSION_ENTRY_SUCCESS';

export const ADD_DISCUSSION_REPLY_REQUEST = 'ADD_DISCUSSION_REPLY_REQUEST';
export const ADD_DISCUSSION_REPLY_SUCCESS = 'ADD_DISCUSSION_REPLY_SUCCESS';
export const ADD_DISCUSSION_REPLY_FAILURE = 'ADD_DISCUSSION_REPLY_FAILURE';

export const FETCH_DISCUSSION_REPLIES_REQUEST =
  'FETCH_DISCUSSION_REPLIES_REQUEST';
export const FETCH_DISCUSSION_REPLIES_SUCCESS =
  'FETCH_DISCUSSION_REPLIES_SUCCESS';
export const FETCH_DISCUSSION_REPLIES_FAILURE =
  'FETCH_DISCUSSION_REPLIES_FAILURE';

export const TOGGLE_LECTURE_QUESTION_UPVOTE_REQUEST =
  'TOGGLE_LECTURE_QUESTION_UPVOTE_REQUEST';
export const TOGGLE_LECTURE_QUESTION_UPVOTE_FAILURE =
  'TOGGLE_LECTURE_QUESTION_UPVOTE_FAILURE';
export const TOGGLE_LECTURE_QUESTION_UPVOTE_SUCCESS =
  'TOGGLE_LECTURE_QUESTION_UPVOTE_SUCCESS';

export const TOGGLE_GENERAL_QUESTION_UPVOTE_REQUEST =
  'TOGGLE_GENERAL_QUESTION_UPVOTE_REQUEST';
export const TOGGLE_GENERAL_QUESTION_UPVOTE_FAILURE =
  'TOGGLE_GENERAL_QUESTION_UPVOTE_FAILURE';
export const TOGGLE_GENERAL_QUESTION_UPVOTE_SUCCESS =
  'TOGGLE_GENERAL_DISCUSSION_UPVOTE_SUCCESS';

export const TOGGLE_REPLY_UPVOTE_REQUEST = 'TOGGLE_REPLY_UPVOTE_REQUEST';
export const TOGGLE_REPLY_UPVOTE_FAILURE = 'TOGGLE_REPLY_UPVOTE_FAILURE';
export const TOGGLE_REPLY_UPVOTE_SUCCESS = 'TOGGLE_REPLY_UPVOTE_SUCCESS';

export const TOGGLE_QUESTION_UPVOTE_REQUEST = 'TOGGLE_QUESTION_UPVOTE_REQUEST';
export const TOGGLE_QUESTION_UPVOTE_FAILURE = 'TOGGLE_QUESTION_UPVOTE_FAILURE';
export const TOGGLE_QUESTION_UPVOTE_SUCCESS = 'TOGGLE_QUESTION_UPVOTE_SUCCESS';

export const DELETE_QUESTION_REQUEST = 'DELETE_QUESTION_REQUEST';
export const DELETE_QUESTION_FAILURE = 'DELETE_QUESTION_FAILURE';
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS';

export const DELETE_REPLY_REQUEST = 'DELETE_REPLY_REQUEST';
export const DELETE_REPLY_FAILURE = 'DELETE_REPLY_FAILURE';
export const DELETE_REPLY_SUCCESS = 'DELETE_REPLY_SUCCESS';

export const EDIT_QUESTION_REQUEST = 'EDIT_QUESTION_REQUEST';
export const EDIT_QUESTION_FAILURE = 'EDIT_QUESTION_FAILURE';
export const EDIT_QUESTION_SUCCESS = 'EDIT_QUESTION_SUCCESS';

export const EDIT_REPLY_REQUEST = 'EDIT_REPLY_REQUEST';
export const EDIT_REPLY_FAILURE = 'EDIT_REPLY_FAILURE';
export const EDIT_REPLY_SUCCESS = 'EDIT_REPLY_SUCCESS';

export const SYNC_EXISTING_QUESTIONS_REQUEST =
  'SYNC_EXISTING_QUESTIONS_REQUEST';
export const SYNC_EXISTING_QUESTIONS_FAILURE =
  'SYNC_EXISTING_QUESTIONS_FAILURE';
export const SYNC_EXISTING_QUESTIONS_SUCCESS =
  'SYNC_EXISTING_QUESTIONS_SUCCESS';
  
export const SYNC_QUESTION_VOTE = 'SYNC_QUESTION_VOTE';

export const SYNC_REPLY_VOTE = 'SYNC_REPLY_VOTE';

export const SYNC_EXISTING_REPLIES_REQUEST =
  'SYNC_EXISTING_REPLIES_REQUEST';
export const SYNC_EXISTING_REPLIES_FAILURE =
  'SYNC_EXISTING_REPLIES_FAILURE';
export const SYNC_EXISTING_REPLIES_SUCCESS =
  'SYNC_EXISTING_REPLIES_SUCCESS';

export const UPDATE_QUESTION_REPLIES_COUNT = 'UPDATE_QUESTION_REPLIES_COUNT';

export const SYNC_QUESTION_DETAILS_VOTE = 'SYNC_QUESTION_DETAILS_VOTE';
